module.exports = __webpack_public_path__ + "img/app-screen_3.124eb803.webp";